import * as React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { match } from "react-router-dom"; //needed for 'location' object and 'match.params'
import { mapDispatchToProps, updateReduxAction } from "../../redux/actions";
import "../../css/FactoryRequests.scss";
import {
  formatDate,
  getFactoryRequestEmailValidationMessage
} from "./FactoryRequestUtility";
import { getSelectedProject } from "../Project/ProjectUtilities";
import { basisOfDesignOptions, normalizeBasisOfDesign } from "../../utilities/basisOfDesignOptions";
// expected props
interface IProps {
  updateRedux: any;
  reduxFactoryDesignDetails:any;
  reduxProjectManagement:any;
  match: match<any>;
  pricingInvalid:boolean;
  basisOfDesignInvalid:boolean;
}
// local state
interface IState {
    emailError: string;
    bidDateError:string;
    showPricingTooltip:boolean;
    currentEmail:string;
}

class DesignInputs extends React.Component<IProps, IState> {

  public state: IState = {
    emailError: "",
    bidDateError: "",
    showPricingTooltip:false,
    currentEmail:""
  };
  async componentDidMount() {
    const { projectId, unitId } = this.props.match.params;
    //Protect against refresh on this page.  Need to repopulate reduxProjectManagement if refresh occurs.
    if (!this.props.reduxProjectManagement.selectedProject){
      await getSelectedProject("proj-" + projectId);
    }

    const today = new Date();
    const firstValidDate = this.addWorkingDays(today, 5);
    let basisOfDesign:string = "";

    if (this.props.reduxProjectManagement?.selectedProject?.designBasis && this.props.reduxProjectManagement.selectedProject.designBasis !== ""){
      basisOfDesign = normalizeBasisOfDesign(this.props.reduxProjectManagement.selectedProject.designBasis);
    }
    this.prepopulateProjectInfoData(formatDate(firstValidDate), basisOfDesign);
  }
  public render() {
    const minDate = formatDate(
      this.addWorkingDays(new Date(), 5)
    );
    const invalidEmailClass = this.state.emailError ? "email-error" : "app-display-none";
    let showBidDate = this.props.reduxFactoryDesignDetails.designRequestDetails.Pricing === "Quote";
    return (
      <div className="request-inputs">
        <div className="div-input">
        <label className="label-width">Pricing *</label>
            <select
                className={this.props.pricingInvalid ? "input-required-error" : ""}
                value={this.props.reduxFactoryDesignDetails.designRequestDetails.Pricing}
                onChange={(e) => this.updateReduxDesignInputs("Pricing", e.target.value )}
            >
                <option value="" disabled>Select Pricing</option>
                <option>No</option>
                <option>Quote</option>
            </select>

            {/* Tooltip */}
            <div
              className="tooltip-wrapper"
              onMouseEnter={() => this.setState({ showPricingTooltip: true })}
              onMouseLeave={() => this.setState({ showPricingTooltip: false })}
            >
              <span className="design-tooltip-info"></span>

              {this.state.showPricingTooltip && (
                <div className="tooltip-box">
                  A request for quote/bid pricing may extend the turnaround time.
                </div>
              )}
            </div>
        </div>
        
        {showBidDate ? (
        <div className="div-input">
            <label className="label-width">Bid Date</label>
            <input
                type="date"
                value={this.props.reduxFactoryDesignDetails.designRequestDetails.BidDate}
                min={minDate}
                onKeyDown={(e) => e.preventDefault()}//Does not allow manually editing the date.
                onChange={(e) => this.updateReduxDesignInputs("BidDate", e.target.value )}
            />
        </div>
        ) : null}

        <div className="div-input">
            <label className="label-width">Basis of Design *</label>
            <select
                className={this.props.basisOfDesignInvalid ? "input-required-error" : ""}
                value={this.props.reduxFactoryDesignDetails.designRequestDetails.BasisOfDesign}
                onChange={(e) => this.updateReduxDesignInputs("BasisOfDesign", e.target.value )}
            >
                <option value="" disabled>Select Basis</option>
                {basisOfDesignOptions.filter((option) => option !== "").map((option) => <option key={option} value={option}>{option}</option>)}
            </select>
        </div>
        
        {/* ADDTIONAL EMAIL RECIPIENTS */}
        <div className="div-input">
          <label className="email-label">Additional Email Recipients:</label>
          <ul>
          {this.props.reduxFactoryDesignDetails.designRequestDetails.AdditionalEmailRecipients?.map((email:string) => (
          <div key={email}>
            <li className="email-item"> {email}
            <button className="email-delete-button" onClick={() => this.handleRemoveEmail(email)}>
              ×
            </button>
            </li>
          </div>
          ))}
          </ul>
          <div>
            <input
              className="email-input"
              type="text"
              value={this.state.currentEmail}
              onChange={(e) => this.handleEmailChange(e.currentTarget.value)}
              placeholder="Enter email"
              onBlur={(e) => this.setState({emailError:""})}
            />
            <button onClick={this.handleAddEmail}>Add</button>
          </div>
          <div className={invalidEmailClass}>{this.state.emailError}</div>
        </div>  
     </div>
      
    );
  }
  private prepopulateProjectInfoData(bidDate:any, basisOfDesign:string){
    const designDetailsCopy = {...this.props.reduxFactoryDesignDetails};
    
    designDetailsCopy.designRequestDetails.BasisOfDesign = basisOfDesign;
    designDetailsCopy.designRequestDetails.BidDate = bidDate;
    
    this.props.updateRedux("UPDATE_DESIGN_DETAILS", designDetailsCopy);
  }
  private updateReduxDesignInputs(fieldName:string, value:any){
    const designDetails = {...this.props.reduxFactoryDesignDetails};
    designDetails.designRequestDetails[fieldName]= value;
    this.props.updateRedux("UPDATE_DESIGN_DETAILS", designDetails );
  }
  private addWorkingDays(startDate: Date, workingDays: number){
    const result = new Date(startDate);
    let addedDays = 0;
  
    while (addedDays < workingDays) {
      result.setDate(result.getDate() + 1);
  
      const day = result.getDay();
      // Skip Saturday (6) and Sunday (0)
      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }
    return result;
  }
  private handleEmailChange = (value:string) => {
    this.setState({currentEmail:value});
  }
  private handleAddEmail = () => {
    const email = this.state.currentEmail.trim();
    const emailValidationMessage = getFactoryRequestEmailValidationMessage(email);
    if (emailValidationMessage) {
      this.setState({emailError:emailValidationMessage});
      return;
    }
    let emails = this.props.reduxFactoryDesignDetails.designRequestDetails.AdditionalEmailRecipients;
    let copyEmails = [...emails];
    copyEmails.push(email);
    this.updateReduxDesignInputs("AdditionalEmailRecipients", copyEmails);
    this.setState({currentEmail:"", emailError:""});
  }
  private handleRemoveEmail = (emailToRemove:string) => {
    let emails = this.props.reduxFactoryDesignDetails.designRequestDetails.AdditionalEmailRecipients;
    let copyEmails = [...emails];
    this.updateReduxDesignInputs("AdditionalEmailRecipients", copyEmails.filter((email:string) => email !== emailToRemove));
  }
}
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxFactoryDesignDetails: state.reduxFactoryDesignDetails,
    reduxProjectManagement: state.reduxProjectManagement
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(DesignInputs);
